export function setHtmlTitle(title: string) {
    document.title = title + ' - Zywpeit';
}